"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Utils = require("./utils/Utils");

var _ChromeExtensionInstallHelpers = _interopRequireDefault(require("./lib/ChromeExtensionInstallHelpers"));

var _ChromeExtension = _interopRequireDefault(require("./constants/ChromeExtension"));

var _hasExtension = function _hasExtension() {
  return (0, _Utils.objectDoesExist)(window, ['SIG_EXT']);
};

var SidekickExtensionInstallHelpers =
/*#__PURE__*/
function (_ChromeExtensionInsta) {
  (0, _inherits2.default)(SidekickExtensionInstallHelpers, _ChromeExtensionInsta);

  function SidekickExtensionInstallHelpers() {
    (0, _classCallCheck2.default)(this, SidekickExtensionInstallHelpers);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SidekickExtensionInstallHelpers).apply(this, arguments));
  }

  (0, _createClass2.default)(SidekickExtensionInstallHelpers, [{
    key: "setup",
    value: function setup() {
      var ChromeExtensionData = _ChromeExtension.default.sidekick;
      this.extensionUrl = ChromeExtensionData.extensionUrl;
      this._isExtensionInstalled = _hasExtension();
    }
  }, {
    key: "hasExtension",
    value: function hasExtension() {
      return this._isExtensionInstalled || _hasExtension();
    }
  }]);
  return SidekickExtensionInstallHelpers;
}(_ChromeExtensionInstallHelpers.default);

var _default = new SidekickExtensionInstallHelpers();

exports.default = _default;
module.exports = exports.default;